import { axios } from 'lib/axios';
import { queryClient } from 'lib/react-query';
import { useNotificationStore } from 'stores/notifications';
import PropTypes from 'prop-types';
import { useMutation } from 'react-query';

export const deleteFee = ({ id }) => {
  return axios.delete(`/fee/${id}`);
};

deleteFee.propTypes = {
  id: PropTypes.string.isRequired,
};

export const useDeleteFee = ({ config } = {}) => {
  const { addNotification } = useNotificationStore();

  return useMutation({
    onMutate: async (deletedFee) => {
      await queryClient.cancelQueries('fees');

      const previousFees = queryClient.getQueryData('fees');

      queryClient.setQueryData(
        'fees',
        previousFees?.filter((fee) => fee.id !== deletedFee.id)
      );

      return { previousFees };
    },
    onError: (_, __, context) => {
      if (context?.previousFees) {
        queryClient.setQueryData('fees', context.previousFees);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries('fees');
      addNotification({
        type: 'success',
        title: 'Fee Deleted',
      });
    },
    ...config,
    mutationFn: deleteFee,
  });
};
